export enum UpgradeCheckoutEvents {
  Open = 'upgrade-checkout:open',
  Close = 'upgrade-checkout:close',
  Initiated = 'upgrade-checkout:initiated',
  Completed = 'upgrade-checkout:completed',
}

export enum UpgradeCheckoutState {
  Default = 'default',
  AddOns = 'addons',
  Renew = 'renew',
  AddEvents = 'add-events',
}
